import { theme } from '@/shared/design-system/theme'

import { ColorSet } from './color'
import { TypographySet } from './typography'

export interface CellTheme {
  colors: ColorSet
  typography: TypographySet
}

const cellTheme = {
  ...theme,
}

export default cellTheme
